import React from "react";
import "../../Styles/Profile.css";

import { FaRegEdit } from "react-icons/fa";

const ProfileTabs = () => {
  return (
    <div className="d-flex align-items-center flex-wrap gap-2 mb-4">
      <ul
        className="nav nav-pills arrow-navtabs nav-secondary gap-2 flex-grow-1 order-2 order-lg-1"
        role="tablist"
      >
        <li className="nav-item" role="presentation">
          <a
            className="nav-link active"
            data-bs-toggle="tab"
            href="#personalDetails"
            role="tab"
            aria-selected="true"
          >
            Personal Details
          </a>
        </li>
        <li className="nav-item" role="presentation">
          <a
            className="nav-link"
            data-bs-toggle="tab"
            href="#changePassword"
            role="tab"
            aria-selected="false"
            tabIndex={-1}
          >
            Changes Password
          </a>
        </li>

        <li className="nav-item" role="presentation">
          <a
            className="nav-link"
            data-bs-toggle="tab"
            href="#education"
            role="tab"
            aria-selected="false"
            tabIndex={-1}
          >
            Education
          </a>
        </li>
        <li className="nav-item" role="presentation">
          <a
            className="nav-link"
            data-bs-toggle="tab"
            href="#securityPrivacy"
            role="tab"
            aria-selected="false"
            tabIndex={-1}
          >
            Security &amp; Privacy
          </a>
        </li>
      </ul>
    </div>
  );
};
export default ProfileTabs;
